import { createContext } from '@direct-frontend/modules-context';
import { type OpenApiSchemaStoreInfo } from '../../api/schema';

export type StoreInfoRequestContext = {
    /**
     * Забанен ли магазин в Яндекс Товарах
     */
    isBanned: boolean;

    /**
     * Флаг внешнего чекаута.
     * * true - кабинет внешнего чекаута (YCP или Bitrix);
     * * false - кабинет Kit или Kit Lite.
     */
    isExternalCheckout: boolean;

    /**
     * Тип магазина.
     * * Kit - обычный китовый магазин (isExternal=false)
     * * YCP - внешний чекаут со способом подключения YCP (isExternal=true)
     * * Bitrix - внешний чекаут со способом подключения YCP для битрикса (isExternal=true)
     * * RemoteORM - наше кастомное решение для селлера, на фронте можно игнорировать (isExternal=false)
     * * Lite - чекаут магазина без собственного сайта - для вывода на поверхностях Поиска и Алисы (isExternal=false)
     */
    type: OpenApiSchemaStoreInfo['store_type'];

    /**
     * @description Момент завершения шага онбординга «Опубликовать магазин»:
     * для внешнего магазина — этап publish-store, для остальных — publish.
     * Одновременно актуален только один вариант. null, если соответствующий шаг ещё не отмечен выполненным.
     * @format date-time
     */
    publishStepCompletedAt?: string | null;

    /**
     * @description Тексты причин блокировки домена по модерации (пока заглушка на бэкенде).
     */
    domainBlockReasons: string[];

    /**
     * @description Доступна ли ручная отправка домена на перемодерацию (пока заглушка на бэкенде).
     */
    canRequestDomainRemoderation: boolean;

    /**
     * Домен внешнего магазина, который мерчант указал при регистрации.
     * Для китовых магазинов может быть пустой строкой либо некорректным значением.
     */
    nonInternalB2cHost: string;
};

/** Контекст, хранящий основную информацию о текущем магазине */
export const { getContext: getStoreInfoRequestContext, setContext: setStoreInfoRequestContext } =
    createContext<StoreInfoRequestContext>({
        name: 'storeInfoRequestContext',
    });

export const getSafeStoreInfoRequestContext = (): StoreInfoRequestContext => {
    try {
        return getStoreInfoRequestContext();
    } catch (_) {
        return {
            isBanned: false,
            isExternalCheckout: false,
            type: 'Kit',
            publishStepCompletedAt: null,
            domainBlockReasons: [],
            canRequestDomainRemoderation: false,
            nonInternalB2cHost: '',
        };
    }
};
